'use client';

import dynamic from 'next/dynamic';
import { FC } from 'react';

import { CircularProgress } from 'src/general/components/CircularProgress/CircularProgress';

import { YourirPrices } from '../../AsxAnnouncements/AsxAnnouncements.types';

type Props = {
  values: YourirPrices['result'];
};

const InvestorShareInfoGraphContent = dynamic(
  () => import('./InvestorShareInfoGraphContent').then((mod) => mod.InvestorShareInfoGraphContent),
  {
    ssr: false,
    loading: () => (
      <div className="flex h-100 items-center justify-center">
        <CircularProgress />
      </div>
    ),
  },
);

export const InvestorShareInfoGraph: FC<Props> = ({ values }) => {
  if (!values || values.length === 0) return null;

  const sortedValues = [...values].sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime());

  const data = sortedValues.map((item) => ({
    date: item.date,
    volume: item.volume,
    close: item.close,
  }));

  // Calculate price domain to start closer to minimum (not from 0)
  const prices = data.map((item) => item.close);
  const maxPrice = Math.max(...prices);
  const priceDomain: [number, number] = [0, maxPrice * 1.1];

  // Only show first and last date on X-axis
  const xAxisTicks = data.length > 0 ? [data[0].date, data.at(-1)!.date] : [];

  return (
    <div className="relative overflow-hidden rounded-xl border border-bor-neu-mut bg-bac-tie1">
      <header className="flex flex-col border-b border-bor-neu-mut bg-bac-tie2 p-4 sm:flex-row sm:items-center sm:justify-between">
        <h3 className="c-fs-h6 font-extrabold">Market data chart (ASX:CMA)</h3>
        <p className="c-fs-body2 text-tex-def-tie3">Past 30 days</p>
      </header>
      <div className="py-5 smp:px-4">
        <InvestorShareInfoGraphContent data={data} priceDomain={priceDomain} xAxisTicks={xAxisTicks} />
      </div>
    </div>
  );
};
